module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"completed":"{coursePercentageProgress}  Fullført"},"en":{"completed":"{coursePercentageProgress} Completed"}}')
  delete Component.options._Ctor
}
